// extracted by mini-css-extract-plugin
module.exports = {"content":"ActivityCopyDialog_content__7z5NQ","nameContainer":"ActivityCopyDialog_nameContainer__2wYAd","courseContainer":"ActivityCopyDialog_courseContainer__1JWgN"};